import useMediaQuery from '@mui/material/useMediaQuery'

export const useResponsive = () => {
  return {
    isMobile: useMediaQuery('(max-width:640px)'),
    isDesktop: useMediaQuery(`(min-width: 640px)`),
  }
}
